import React from 'react';
import { useUserRoles } from '../../hooks/useUserRoles';
import { AdminDashboard } from './AdminDashboard';
import { ManagerDashboard } from './ManagerDashboard';
import { UserDashboard } from './UserDashboard';
import { ViewerDashboard } from './ViewerDashboard';

export const AppUserDashboard: React.FC = () => {
  const { user, isAdmin, isManager, loading } = useUserRoles();

  if (loading) {
    return (
      <div className="flex items-center justify-center min-h-64">
        <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-primary-600"></div>
      </div>
    );
  }

  if (!user) {
    return (
      <div className="text-center py-12">
        <p className="text-gray-500 dark:text-gray-400">
          Impossible de charger les données utilisateur
        </p>
      </div>
    );
  }

  // Determine dashboard type based on user role
  if (isAdmin) {
    return <AdminDashboard user={user} />;
  }

  if (isManager) {
    return <ManagerDashboard user={user} />;
  }

  // Check for viewer role (read-only access)
  const isViewer = user.roles.some(role => role.level === 'viewer');
  if (isViewer) {
    return <ViewerDashboard user={user} />;
  }

  // Default to standard user dashboard
  return <UserDashboard user={user} />;
};
